import { sessionStore } from 'stores';

import { mainConditions } from '../../selectors/mainConditions';
import { confirmationStore } from '../../stores';

function logoutIfConfirmation() {
  if (mainConditions.isConfirmation.get() && !mainConditions.isPaymentRedirect()) {
    // Only logout if the currently logged-in user's email doesn't match 
    // the confirmation token email (the invited user)
    const sessionEmail = (sessionStore.session.user?.email || '').toLowerCase();
    const tokenEmail = (confirmationStore.tokenData?.email || '').toLowerCase();

    // If user is logged in and emails match, don't logout - they're the right user
    if (sessionStore.isAuth && sessionEmail && tokenEmail && sessionEmail === tokenEmail) {
      return;
    }

    sessionStore.logout();
  }
}

export { logoutIfConfirmation };
